var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMainSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 66,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 20,
    height: 28,
    x: 6,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.55 4.164 6.141 22.703c-.14.347.106.727.468.727h9.714c.25 0 .464.191.5.448l1.142 7.898a.252.252 0 0 0 .485.062l7.407-18.54c.14-.348-.107-.728-.468-.728h-9.714a.513.513 0 0 1-.5-.448l-1.142-7.898a.252.252 0 0 0-.485-.062v.002Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M5.381 3.104h21.237v29.624H5.381z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.707,
    cy: 29.172,
    fill: "url(#c)",
    rx: 15.609,
    ry: 15.764
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.683,
    cy: 25.924,
    fill: "url(#d)",
    rx: 15.609,
    ry: 15.764
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.956,
    cy: 6.464,
    fill: "url(#e)",
    rx: 13.613,
    ry: 17.696
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 30,
    height: 24,
    x: 1,
    y: 38,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.829 49.127c0-2.309.85-4.478 2.393-6.11a.87.87 0 0 0 0-1.18.76.76 0 0 0-1.115 0c-1.841 1.947-2.855 4.537-2.855 7.29 0 3.272 1.42 6.278 3.899 8.245a.754.754 0 0 0 .473.167c.24 0 .475-.115.631-.333a.865.865 0 0 0-.157-1.167c-2.077-1.65-3.268-4.17-3.268-6.912h-.001Zm-3.832-.192c0-3.389 1.248-6.575 3.515-8.972.4-.424.4-1.11 0-1.534a.988.988 0 0 0-1.45 0c-2.654 2.807-4.116 6.538-4.116 10.507 0 4.717 2.049 9.049 5.62 11.886a.98.98 0 0 0 .615.218c.312 0 .62-.15.821-.432a1.125 1.125 0 0 0-.204-1.518c-3.052-2.424-4.801-6.124-4.801-10.152v-.003Zm7.76.383c0-1.198.44-2.325 1.242-3.171a.713.713 0 0 0 0-.968.624.624 0 0 0-.915 0c-1.046 1.105-1.622 2.575-1.622 4.14 0 1.859.808 3.565 2.214 4.683a.625.625 0 0 0 .906-.137.71.71 0 0 0-.128-.958c-1.079-.855-1.697-2.164-1.697-3.588v-.001Zm14.122-10.949a.987.987 0 0 0-1.45.008 1.127 1.127 0 0 0 .008 1.533c2.3 2.404 3.565 5.608 3.565 9.025 0 4.028-1.75 7.73-4.8 10.153a1.126 1.126 0 0 0-.204 1.518c.202.282.51.432.82.432a.98.98 0 0 0 .616-.218c3.571-2.838 5.62-7.17 5.62-11.887 0-4-1.482-7.754-4.174-10.567l-.001.003Zm-3.026 3.428a.757.757 0 0 0-1.115.006.867.867 0 0 0 .005 1.18c1.565 1.635 2.427 3.817 2.427 6.144 0 2.743-1.191 5.262-3.269 6.912a.865.865 0 0 0-.157 1.167.774.774 0 0 0 .631.333.748.748 0 0 0 .474-.167c2.477-1.967 3.897-4.973 3.897-8.245 0-2.775-1.028-5.379-2.894-7.33Zm-2.962 3.357a.623.623 0 0 0-.914.006.711.711 0 0 0 .006.968 4.586 4.586 0 0 1 1.26 3.19c0 1.424-.619 2.734-1.697 3.59a.71.71 0 0 0-.129.957.625.625 0 0 0 .906.137c1.407-1.117 2.214-2.824 2.214-4.683 0-1.577-.584-3.054-1.645-4.165ZM16 47.711c-.8 0-1.448.685-1.448 1.531 0 .846.648 1.53 1.448 1.53.8 0 1.447-.684 1.447-1.53s-.648-1.53-1.447-1.53Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1.946 38.056h28.108v23H1.946z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M20.441 35.762h9.613v15.053L20.44 35.762Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 15.764 -15.609 0 23.707 29.172)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#8C2462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2362",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 15.764 -15.609 0 7.683 25.924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#DB025D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC035C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 17.696 -13.6128 0 9.956 6.464)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#FDD21E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCD1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 16,
    x2: 16,
    y1: 3.104,
    y2: 32.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA2D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 16,
    x2: 16,
    y1: 38.056,
    y2: 61.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60B5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 23.689,
    x2: 30.01,
    y1: 36.092,
    y2: 50.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2581C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2266B3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 13.613,
    height: 19.053,
    x: 18.441,
    y: 33.762,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_202_284",
    stdDeviation: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMainSmall);
export default __webpack_public_path__ + "static/media/logo-main-small.27f58de79da20dac42c581e8c2d7bdd1.svg";
export { ForwardRef as ReactComponent };